import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Autocomplete, Button } from '@avangard/ui/core';

import { FormStyled } from '@modules/layout/styled';
import { Form } from '@modules/layout/organisms';

import type { LapEntity } from '@modules/lap/entities';
import type { CreateLapAccessFormValues, UpdateLapAccessFormValues } from '@modules/lap/requests';

type LapAccessFormProps = {
    laps: (LapEntity | null)[];
    onCancel: () => void;
};

const StyledForm = styled(Form)`
    width: 100%;

    > * {
        &:not(:last-of-type) {
            margin-bottom: 24px;
        }
    }
`;

const FormRowSubmit = styled(FormStyled.FormRowSubmit)`
    justify-content: flex-end;
`;

const StudentLapAccessForm = (props: LapAccessFormProps) => {
    const { laps, onCancel } = props;

    const { t } = useTranslation(['common']);

    const { values, errors, setFieldValue, isSubmitting } = useFormikContext<
        CreateLapAccessFormValues | UpdateLapAccessFormValues
    >();

    const handleChangeAutocompleteField =
        <T extends any>(field: string) =>
        (_: React.ChangeEvent<{}>, value: T | null) =>
            setFieldValue(field, value);

    return (
        <StyledForm>
            <Autocomplete<LapEntity | null, false, false, false>
                fullWidth
                id='lap'
                label={t('common:forms.labels.lap') ?? ''}
                placeholder={t('common:forms.placeholder.choose_lap') ?? ''}
                options={laps}
                value={values.lap}
                error={!!errors.lap}
                helperText={errors.lap}
                getOptionLabel={option => option?.getFormattedName() ?? '-'}
                onChange={handleChangeAutocompleteField<LapEntity>('lap')}
            />

            <FormRowSubmit>
                <Button variant='outlined' disabled={isSubmitting} onClick={onCancel}>
                    {t('common:actions.cancel')}
                </Button>

                <Button type='submit' loading={isSubmitting}>
                    {t('common:actions.submit')}
                </Button>
            </FormRowSubmit>
        </StyledForm>
    );
};

export { StudentLapAccessForm };
